import React from "react";
import { isEmpty, orderBy } from "lodash";
// components
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
  } from "react-accessible-accordion";
// enums
import EViewType from "@/cms/enums/EViewType";
// types
import TRMDRAccordion from "../type";
// utilities
import SanitizeHTMLString from "@/utilities/SanitizeHTMLString";


const RMDRAccordion01 = ( props:TRMDRAccordion ) => {
    console.log("RMDRAccordion01.rendered", props);

    if ( 
        !isEmpty(props.parentLanguageVersion) && props.parentLanguageVersion && 
        !isEmpty(props.parentLanguageVersion?.id) && props.parentLanguageVersion?.id && 
        props.parentLanguageVersion.viewType === EViewType.ACCORDION 
    ) {

        let payloadChild = props.languageVersions?.filter((item) => item.parentId === props.parentLanguageVersion?.id);

        if ( isEmpty(payloadChild) ) return null;

        payloadChild = orderBy(payloadChild, ['order'],['asc']);

        return (
            <div className="faq-accordion">
                <Accordion allowZeroExpanded preExpanded={[payloadChild[0].id]}>
                    {
                        payloadChild.map((item) => (
                            <AccordionItem uuid={item.id}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>{item.name}</AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel className="accordion__panel ck-content" dangerouslySetInnerHTML={{ __html: SanitizeHTMLString(item?.value)}} />
                            </AccordionItem>
                        ))
                    }
                </Accordion>
            </div>
        );

    }

    return null;
}

const Component = React.memo(RMDRAccordion01, ( prevProps:TRMDRAccordion, nextProps:TRMDRAccordion ) => {
    console.log("RMDRAccordion01.memo", { prevProps, nextProps });
    return !( 
        prevProps.isLoading !== nextProps.isLoading 
        || prevProps.parentLanguageVersion !== nextProps.parentLanguageVersion
    );
});

export default Component;